import type { COUPON_DISCOUNT } from "@/types/form-types"
import { Percent, Tag } from "lucide-react"

interface CouponsProps {
	coupon_discount?: COUPON_DISCOUNT
	currency: string
}

function Coupons({ coupon_discount, currency }: CouponsProps) {
	return (
		<div className="space-y-5">
			<p className="flex items-center gap-2">
				<Tag className="size-4" /> <span>Coupons</span>
			</p>

			<div className="flex w-max min-w-40 items-center justify-center gap-1 rounded-xl border-2 border-dashed border-[#189842] bg-[#E8F5EC] px-5 py-3">
				{coupon_discount?.discount_type === "FIXED" && (
					<span>{currency}</span>
				)}{" "}
				{coupon_discount?.discount}{" "}
				{coupon_discount?.discount_type === "PERCENTAGE" && (
					<span>
						<Percent className="size-4" />
					</span>
				)}
				<span>off</span>
			</div>
		</div>
	)
}

export default Coupons
